// Fundo do topo: o poster (imagem) vem sempre no HTML; o loop sem som só é montado depois da hidratação e
// só se o visitante não pediu menos movimento (prefers-reduced-motion) — assim não pesa no LCP.
// Os vídeos não estão no git: servem-se de /media/ (MEDIA_DIR; deploy/cax/upload-media.ps1).
import { MEDIA_FILES, mediaUrl } from "@ecliptica/config/media";
import { useEffect, useState } from "react";

export const HERO_POSTER = "/bg/hero-poster.webp";

export function HeroVideo() {
  const [play, setPlay] = useState(false);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const q = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setPlay(!q.matches);
    update();
    q.addEventListener("change", update);
    return () => q.removeEventListener("change", update);
  }, []);
  return (
    <>
      <div aria-hidden className="absolute inset-0 -z-20 scale-[1.04] bg-cover bg-center brightness-[.6]" style={{ backgroundImage: `url(${HERO_POSTER})` }} />
      {play && (
        <video
          aria-hidden
          tabIndex={-1}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={HERO_POSTER}
          onPlaying={() => setReady(true)}
          className={`absolute inset-0 -z-10 size-full object-cover brightness-[.6] transition-opacity duration-1000 ${ready ? "opacity-100" : "opacity-0"}`}
        >
          <source src={mediaUrl(MEDIA_FILES.heroWebm)} type="video/webm" />
          <source src={mediaUrl(MEDIA_FILES.heroMp4)} type="video/mp4" />
        </video>
      )}
    </>
  );
}
